var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:[
    'tw-flex tw-flex-row tw-items-center',
    { 
      'tw-pr-6': !_vm.noLabel,
    }],attrs:{"id":_vm.id + '__fb_checkbox__'}},[_c('article',[(_vm.isSwitch)?_c('label',{class:[
        'tw-h-5 tw-w-10',
        'tw-inline-flex tw-items-center',
        'tw-rounded-[10px]',
        'tw-bg-white',
        'tw-border-gray-400 tw-border',
        'tw-transition-[color]',
        'tw-cursor-pointer',
        'tw-justify-start',
        'before:tw-bg-gray-400',
        'before:tw-transition',
        'before:tw-transform',
        'before:tw-left-0', 
        'before:tw-relative',
        'before:tw-h-4 before:tw-w-4',
        'before:tw-rounded-[10px]',
        '!tw-py-[2.5px] !tw-pr-[2.5px] !tw-pl-[1.5px]',
        _vm.resolveTransitionClass,
        {
          '!tw-bg-emerald-500': _vm.isSelected,
          '!tw-border-emerald-500': _vm.isSelected,
          '!tw-cursor-default': _vm.disabled,
          'before:tw-translate-x-[19px]': _vm.isSelected && _vm.isStacked,
          'tw-mb-0': _vm.isStacked,
          'before:!tw-bg-white': _vm.isSelected,
          'before:!tw-cursor-default': _vm.disabled,
        }],attrs:{"for":_vm.id + '__fb_checkbox__input'}}):_c('label',{class:[
        'tw-h-[15px] tw-w-[15px]',
        'tw-mb-u',
        'tw-inline-flex tw-justify-center tw-items-center',
        'tw-border tw-border-gray-300 tw-rounded-[3px]',
        'tw-bg-gray-300',
        'tw-transition-[background]',
        'tw-cursor-pointer',
        '!tw-pb-u !tw-pl-u', // remove global inherited values
        {
          '!tw-bg-primary !tw-border-primary': _vm.isSelected,
        }],attrs:{"for":_vm.id + '__fb_checkbox__input'}},[(_vm.isSelected)?_c('CheckIcon',{staticClass:"tw-text-white tw-stroke-[4]",attrs:{"size":"0.75x"}}):_vm._e()],1),_c('input',{staticClass:"tw-hidden",attrs:{"id":_vm.id + '__fb_checkbox__input',"type":"checkbox"},domProps:{"checked":_vm.isSelected,"value":_vm.value},on:{"change":function($event){if($event.target !== $event.currentTarget)return null;$event.preventDefault();return _vm.toggleChange.apply(null, arguments)}}})]),(!_vm.noLabel)?_c('article',{staticClass:"tw-w-auto"},[_c('label',{ref:"slotLabel",class:[
        'tw-font-semibold tw-text-sm !tw-leading-[17px]',
        _vm.slotClasses,
        {
          'tw-mb-u tw-mt-[-0.375rem] tw-pl-6': !_vm.slotClasses,
        }],attrs:{"for":_vm.id + '__fb_checkbox__input'}},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }